export enum CargoTypeEnum {
  none = 0,
  package = 1,
  document = 2
}
